import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import * as turf from "@turf/turf";
import * as summary from "geojson-summary";
import numeral from "numeral";
import React, { useState } from "react";
import { Actions } from "./Actions";
import { LayerColorPicker } from "./LayerColorPicker";
import { VerticalSpace } from "./VerticalSpace";
import * as _ from "lodash";
const useStyles = makeStyles({
  table: {
    // width: "100%"
    minWidth: 300
  }
});

function createData(name, value) {
  return { name, value };
}

const getCentroid = layer =>
  turf
    .centroid(layer)
    .geometry.coordinates.map(e => e.toFixed(4))
    .join(", ");

const getCenter = layer =>
  turf
    .center(layer)
    .geometry.coordinates.map(e => e.toFixed(4))
    .join(", ");

export const PopoverContent = ({ layer, handleClose }) => {
  const isPoint = layer.type === "Point";
  const isFeature = layer.type === "Feature";

  const bb = turf.bbox(layer);
  const bottomLeft = [bb[0], bb[1]];
  const topLeft = [bb[0], bb[3]];
  const height = turf.distance(bottomLeft, topLeft);

  const bottomRight = [bb[2], bb[1]];
  const width = turf.distance(bottomLeft, bottomRight);

  const [contentKey, setContentKey] = useState(null);
  const rows = [
    createData("Short ID", layer._id.substring(layer._id.length - 3)),
    createData(
      "Area",
      `${numeral(turf.area(layer) / 1e6).format("0 a")} sq km`
    ),
    createData("Centroid x,y", getCentroid(layer)),
    createData("Center x,y", getCenter(layer)),
    createData(
      "Height",
      isPoint ? "Point" : `${numeral(height).format("0 a")} km`
    ),
    createData(
      "Width",
      isPoint ? "Point" : `${numeral(width).format("0 a")} km`
    ),
    createData("Line color", <LayerColorPicker layer={layer} />)
  ];
  const classes = useStyles();

  const geomType = _.get(layer, ["geometry", `type`]);

  return (
    <div className="popover">
      {contentKey && (
        <div>
          <button className="link-button" onClick={() => setContentKey(null)}>
            Go Back
          </button>
          <VerticalSpace m />
        </div>
      )}
      {contentKey ? (
        contentKey
      ) : (
        <div style={{ display: "flex" }}>
          {/* Left side */}
          <div style={{ paddingRight: "1.5em" }}>
            {/* Title */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <div>
                {layer.type} {geomType && ` / ${geomType}`}
              </div>
              <div>{!isFeature && summary(layer).sentence}</div>
            </div>
            <VerticalSpace s />
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  {rows.map(row => (
                    <TableRow key={row.name}>
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <VerticalSpace m></VerticalSpace>
          </div>
          {/* Right side */}
          <div>
            <div>Actions</div>
            <VerticalSpace s />

            <Actions
              layer={layer}
              setContentKey={setContentKey}
              handleClose={handleClose}
            ></Actions>
          </div>
        </div>
      )}
    </div>
  );
};
